import * as React from 'react'
// libs
import { useDispatch } from 'react-redux'
import { arrayRemoveAll, FieldArray, InjectedFormProps, reduxForm } from 'redux-form'
// components
import { Button, BUTTON_LAYOUTS } from 'components/UI'
import { ReduxInput, ReduxSelect, ReduxSwitch } from 'components/FormElements/ReduxForm'
// view components
import DeleteButton from './components/DeleteButton'
import renderConditions from './components/Conditions'
import renderTransactions from './components/Transactions'
import EmailPreviewModal from 'components/Modals/EmailPreviewModal'
import FieldRecurrenceModal from 'components/Modals/ReccurenceSettingsModal'
// types
import { IOption } from 'components/FormElements/Select'
// constants
import { Forms, Modals, OBJECTS_OPTIONS, PROCESS_TYPE_OPTIONS } from 'constants/index'
// hooks
import { useModalData } from 'hooks/index'
// views
import { BottomPaper, Form, Wrapper } from './views'
// utils
import { required } from 'utils/index'
// context
import { RiskTemplateAPIContext } from 'containers/Risks/RiskTemplate/Edit/layers/API'

interface IIncomingProps {
  hideModal: () => void
  deleteSystemProcess: any
}

interface IFormData {
  active: boolean
  name: string
  processType: IOption
  object: IOption
}

type IFormProps = InjectedFormProps<IFormData>

const SystemProcessCreateForm: React.FC<IFormProps & IIncomingProps> = ({ handleSubmit, deleteSystemProcess }) => {
  const dispatch = useDispatch()

  const { isRiskTemplate } = React.useContext(RiskTemplateAPIContext)

  const {
    hideModal,
    modalData: { isEdit }
  } = useModalData({ modalType: Modals.SYSTEM_PROCESS_CREATE_MODAL })

  // Conditions and transactions are built from the selected object and process type, so they are dropped
  // when either changes. Resetting the whole form here would also revert the selection itself.
  const onSelectChange = () => {
    dispatch(arrayRemoveAll(Forms.SYSTEM_PROCESS_CREATE_FORM, 'conditions'))
    dispatch(arrayRemoveAll(Forms.SYSTEM_PROCESS_CREATE_FORM, 'transactions'))
  }

  return (
    <Form onSubmit={handleSubmit}>
      {isEdit && <DeleteButton removeField={deleteSystemProcess} iconSize={'24px'} />}

      <Wrapper>
        <ReduxSwitch label={'Active'} name={'active'} reverse />
        <ReduxInput label={'Name'} name={'name'} validate={required} />
        <ReduxSelect
          label={'Process Type'}
          name={'processType'}
          onSelectChange={onSelectChange}
          options={PROCESS_TYPE_OPTIONS}
          validate={required}
        />
        <ReduxSelect
          label={'Object'}
          name={'object'}
          onSelectChange={onSelectChange}
          options={OBJECTS_OPTIONS}
          validate={required}
          isDisabled={isRiskTemplate}
        />
        <FieldArray name={'conditions'} component={renderConditions} />
        <FieldArray name={'transactions'} component={renderTransactions} />
        <EmailPreviewModal />
        <FieldRecurrenceModal />
      </Wrapper>

      <BottomPaper square>
        <Button type={'submit'} layout={BUTTON_LAYOUTS.PURPLE}>
          {isEdit ? 'Save' : 'Create'}
        </Button>
        <Button layout={BUTTON_LAYOUTS.WHITE} type={'button'} onClick={hideModal}>
          Cancel
        </Button>
      </BottomPaper>
    </Form>
  )
}

export default reduxForm<any, any>({
  form: Forms.SYSTEM_PROCESS_CREATE_FORM,
  enableReinitialize: true
})(SystemProcessCreateForm)
